import {
  LoadOrganizationMembersQuery,
  LoadSpaceMembersQuery,
} from "~/operations";
import { roleFromMrnString } from "~/lib/iam/roles";
import { BASE_MEMBERS_ROLES } from "../const";

export type SpaceMember = NonNullable<
  NonNullable<
    NonNullable<NonNullable<LoadSpaceMembersQuery["space"]>["members"]>["edges"]
  >[0]["node"]
>;
export type OrgMember = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<LoadOrganizationMembersQuery["organization"]>["members"]
    >["edges"]
  >[0]["node"]
>;
export type Member = OrgMember | SpaceMember;

export const getRoleNameByRoleMrn = (mrn?: string | null) => {
  if (!mrn) return null;
  const role = roleFromMrnString(mrn);
  // remove "Space " from the role title since generated Base Roles have "Space " prefix
  return role?.title?.replace(/^Space /, "") ?? null;
};

export const hasAnyBaseRoleSelected = (newValue: string[]) => {
  return BASE_MEMBERS_ROLES.some((role) => newValue.includes(role.value));
};
